import { render, staticRenderFns } from "./PurchaseItemUpdate.view.vue?vue&type=template&id=67d0fb17&scoped=true&"
import script from "./PurchaseItemUpdate.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemUpdate.view.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseItemUpdate.view.vue?vue&type=style&index=0&id=67d0fb17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0fb17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d0fb17')) {
      api.createRecord('67d0fb17', component.options)
    } else {
      api.reload('67d0fb17', component.options)
    }
    module.hot.accept("./PurchaseItemUpdate.view.vue?vue&type=template&id=67d0fb17&scoped=true&", function () {
      api.rerender('67d0fb17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/update/PurchaseItemUpdate.view.vue"
export default component.exports